// extracted by mini-css-extract-plugin
export var mobilePriceBox = "price-module--mobilePriceBox--SBnpr";
export var mobilePriceProductName = "price-module--mobilePriceProductName--koAVR";
export var mobilePriceDescText = "price-module--mobilePriceDescText--mR96z";
export var mobilePriceText = "price-module--mobilePriceText--OAF6C";
export var mobilePriceSaveText = "price-module--mobilePriceSaveText--nk14A";
export var mobilePriceCheckbox = "price-module--mobilePriceCheckbox--IQNQ2";
export var quantityText = "price-module--quantityText--x0OZF";
export var quantityNumberText = "price-module--quantityNumberText--FoaG4";
export var quantityButton = "price-module--quantityButton--1r96F";